
export enum Position {
  ViceDirector = "vice_director",
  ChiefAccountant = "chief_accountant",
  DepartmentManager = "department_manager",
  HeadOfficerAgencyCenter = "head_officer_agency_center",
  DeputyHeadOfficer = "deputy_head_officer",
  CenterDeputyOfficer = "center_deputy_officer",
  TeamLeader = "team_leader",
  ViceCaptain = "vice_captain",
  Employee = "employee",
  Expert = "expert",
  BranchViceDirector = "branch_vice_director",
  DepartmentEmployee = "department_employee",
  TeamLevelEmployee = "team_level_employee",
  ShiftsLevelEmployee = "shifts_level_employee",
}

export enum PositionCode {
  GD = "GD", //Giám đốc
  PGD = "PGD", // Phó giám đốc
  PTGD = "PTGD", // Phó tổng giám đốc
  KTT = "KTT", // Kế toán trưởng
  TP = "TP", // Trưởng phòng
  TTT = "TTT", // Trưởng trung tâm
  PP = "PP", // Phó phòng
  PTT = "PTT", // Phó trung tâm
  DT = "DT", // Đội trưởng
  DP = "DP", // Đội phó
  ĐT = "ĐT",
  ĐP = "ĐP"
}
export enum TitleCode {
  GD = "GD", //Giám đốc
  PGD = "PGD", // Phó giám đốc
  PTGD = "PTGD", // Phó tổng giám đốc
  KTT = "KTT", // Kế toán trưởng
  TP = "TP", // Trưởng phòng
  TTT = "TTT", // Trưởng trung tâm
  PP = "PP", // Phó phòng
  PTT = "PTT", // Phó trung tâm
  DT = "DT", // Đội trưởng
  DP = "DP", // Đội trưởng
  HCTH = "HCTH",
  CV = "CV",
  NV = "NV",
  NVIE = "NVIÊ",
}

export const posGroups1 = [PositionCode.PGD, PositionCode.PTGD, PositionCode.KTT];
export const posGroups2 = [PositionCode.TP, PositionCode.TTT];
export const posGroups3 = [PositionCode.PP, PositionCode.PTT, PositionCode.DT];
export const posGroups4 = [PositionCode.PTT, PositionCode.DT];

export const titleGroup1 = [TitleCode.PGD, TitleCode.PTGD, TitleCode.KTT];
export const titleGroup2 = [TitleCode.TP, TitleCode.TTT];
export const titleGroup3 = [TitleCode.PP, TitleCode.PTT, TitleCode.DT];
export const titleGroup4 = [TitleCode.PTT, TitleCode.DT];
export const titleGroup5 = [TitleCode.DP];
export const titleGroup6 = [TitleCode.DT];

export const titleGroups = {
  one: [TitleCode.PGD, TitleCode.PTGD, TitleCode.KTT],
  two: [TitleCode.TP, TitleCode.TTT],
  three: [TitleCode.PP, TitleCode.PTT, TitleCode.DT],
  four: [TitleCode.PTT, TitleCode.DT],
  five: [TitleCode.DP],
  six: [TitleCode.DT],
  seven: [TitleCode.HCTH],
  eight: [TitleCode.GD, TitleCode.PGD, TitleCode.PTGD, TitleCode.KTT, TitleCode.TP, TitleCode.TTT, TitleCode.PP, TitleCode.PTT, TitleCode.DT, TitleCode.DP, TitleCode.HCTH],
};
